import { NgModule } from '@angular/core';

import { RootEffects } from './rootEffects';

@NgModule({
  providers: [RootEffects],
})
export class RootEffectsModule {}
